import { IntlShape } from 'react-intl';
import { dateConfig, dateTimeConfig } from '../Settings/config';

export const getHelp = (intl: IntlShape, key: string): string | null => {
  const help: string = intl.formatMessage({id: key, defaultMessage: ''});
  if (!help || help === key || help.trim().length < 1) {
    return null;
  }
  return help;
};

export const localDate = (date: Date, locale: string): string => {
  if (date === undefined) return '';
  return new Intl.DateTimeFormat(locale, dateConfig).format(date);
};

export const localDateTime = (date: Date, locale: string): string => {
  if (date === undefined) return '';
  return new Intl.DateTimeFormat(locale, dateTimeConfig).format(date);
};
